export function parseURL(location: string): any {
	let searchString = '';
	const hashPos = location.indexOf('#');
	let searchPos = location.indexOf('?');
	if (hashPos < searchPos && hashPos >= 0) {
		searchPos = -1;
	}
	if (searchPos > -1) {
		searchString = location.slice(searchPos + 1, hashPos > -1 ? hashPos : location.length);
	}

	const searchParams = searchString.split('&');

	const object: Record<string, string> = {};

	searchParams.forEach((param) => {
		const splitted = param.split('=');
		const key = splitted[0];
		const value = splitted[1];

		object[key] = value;
	});

	return object;
}
